
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import PlanningList from './List';
import PlanningSelection from './Selection';
import PlanningAdd from './Add';
import PlanningEdit from './Edit';


export default class PlanningRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path={['/planning/preview/:id', '/planning']} exact component={PlanningList} />
        <Route path={['/planning/selection/preview/:id', '/planning/selection']} exact component={PlanningSelection} />
        <Route path="/planning/add" exact component={PlanningAdd} />
        <Route path="/planning/add/:id" exact component={PlanningAdd} />
        <Route path="/planning/:id" component={PlanningEdit} />
      </Switch>
    );
  }
}
